export function getColorFromStatusLabel(status) {
    if (status === "in_progress")
        return "blue";
    else if (status === "open")
        return "blue";
    else if (status === "closed")
        return "green";
    else if (status === "cancelled")
        return "black";

    return "black";
}

export function getIconNameFromStatusLabel(status) {
    if (status === "in_progress")
        return "play_arrow";
    else if (status === "open")
        return "paused";
    else if (status === "closed")
        return "check";
    else if (status === "cancelled")
        return "stop";

    return "paused";
}

export function formatStatus(status) {
    if (status === "in_progress" || status === "to_assign" || status === "waiting" || status === "calculated")
        return "En cours";
    else if (status === "open")
        return "En attente de validation";
    else if (status === "closed")
        return "Accepté";
    else if (status === "cancelled")
        return "Annulé";

    return status;
}

export function getStateColor(status) {
    if (status === "in_progress")
        return "in-progress-status-color";
    else if (status === "open")
        return "waiting-status-color";
    else if (status === "closed")
        return "ok-status-color";
    else if (status === "cancelled")
        return "";

    return status;
}
